import 'babel-polyfill';

import Vue from 'vue'
import App from './components/App.vue'
import router from './router'
import store from './store';
import vuetify from './plugins/vuetify';

import Highcharts from 'highcharts';
import HighchartsVue from 'highcharts-vue';
import exportingInit from 'highcharts/modules/exporting';
import exportDataInit from 'highcharts/modules/export-data';
import drilldown from "highcharts/modules/drilldown";

import Initials from './filters/initials';
import {HEARTBEAT_EXEMPTIONS} from './constants'
import {fromUnixTime, subMinutes, isWithinInterval} from 'date-fns';
import VueAnalytics from 'vue-analytics';
import setupInterceptor from './utils/errorResponseHandler';

// google analytics tag: ['UA-1490290-31', 'UA-1490290-32','UA-1490290-29'],
// const googleAnalyticsTag = process.env.VUE_APP_GOOGLE_ANALYTICS_TAG;
let googleAnalyticsTag = 'G-YF59KBX0K9';
if (location.hostname.match('test.education.nsw.gov.au') || location.hostname.match('localhost')) {
  googleAnalyticsTag = 'G-YF59KBX0K9'
} else if (location.hostname.match('pre.education.nsw.gov.au')) {
  googleAnalyticsTag = 'G-YF59KBX0K9';
}

Highcharts.setOptions({
  global: {
    useUTC: false
  }
});

exportingInit(Highcharts);
exportDataInit(Highcharts);
drilldown(Highcharts);

Vue.use(HighchartsVue);

Vue.use(VueAnalytics, {
  id: [googleAnalyticsTag],
  checkDuplicatedScript: true,
  debug: {
    enabled: true, // default value false
    trace: true, // default value false
    sendHitTask: true // default value false
  },
  router,
  autoTracking: {
    pageviewTemplate (route) {
      return {
        page: route.path,
        title: document.title,
        location: window.location.href
      }
    }
  }
});

Vue.config.productionTip = false;

Vue.filter('initials', Initials);

Vue.prototype.$eventHub = new Vue(); // Global event bus

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  created() {
    window.setInterval(this.heartbeat, 20000); //20 seconds
  },
  methods: {
    heartbeat() {
      if (
        !HEARTBEAT_EXEMPTIONS.find(
          item => item === this.$router.history.current.name
        )
      ) {
        this.checkTokenExpiry();
      }
    },
    checkTokenExpiry() {
      console.log('checkTokenExpiry');
      if (this.$store.state.auth.token && this.$store.state.auth.exp) {
        // exp is a unix timestamp, use fromUnixTime to get utc zero offset time then convert it to local time.
        const expTime = fromUnixTime(this.$store.state.auth.exp);
        console.log('expTime:' + expTime.toString());
        const localExpTime = new Date(expTime.toISOString());
        console.log('localExpTime:' + localExpTime.toString());

        const nowTime = new Date();
        const reachingTime = subMinutes(nowTime, 1);
        console.log('nowTime:' + nowTime.toString());
        console.log('reachingTime:' + reachingTime.toString());
        if (isWithinInterval(localExpTime, {start: reachingTime, end: nowTime})) {
          console.log('hasNearlyExpired');
          this.$eventHub.$emit('tokenNearlyExpired');
        }
      }
    }
  }
}).$mount('#app');

const axioInterceptor = setupInterceptor.bind(Vue);

axioInterceptor();

/* Custom Highcharts Nav DOTS */
Highcharts.SVGRenderer.prototype.symbols.dots = function (x, y, w, h) {
  var path = [
    // Dot 1
    'M', x + w * 0.5, y,
    'L', x + w * 0.5, y,
    // Dot 2
    'M', x + w * 0.5, y + h * 0.4,
    'L', x + w * 0.5, y + h * 0.4,
    // Dot 3
    'M', x + w * 0.5, y + h * 0.8,
    'L', x + w * 0.5, y + h * 0.8,
  ];
  return path;
};
/* Custom Highcharts Theme - Global stylesheet for charts */
Highcharts.theme = {
  chart: {
    backgroundColor: {
      linearGradient: [0, 0, 100, 100],
      stops: [
        [0, 'rgb(255, 255, 255)'],
        [1, 'rgb(255, 255, 255)']
      ]
    },
  },
  title: {
    align: screenLeft,
    floating: false,
    style: {
      color: '#000000',
      font: 'normal 16px Arial, Helvetica, sans-serif'
    }
  },
  subtitle: {
    align: screenLeft,
    floating: false,
    style: {
      color: '#666666',
      font: 'normal 12px Arial, Helvetica, sans-serif',
      aign: 'left'
    }
  },

  legend: {
    itemStyle: {
      font: '9pt Arial, Helvetica, sans-serif',
      color: '#333333'
    },
    itemHoverStyle: {
      color: 'gray'
    }
  },
  drilldown: {
    activeDataLabelStyle: {
      color: '#43425d',
      textDecoration: 'none',
      fontWeight: 'normal'
    },
  },
  navigation: {
    buttonOptions: {
      symbolStroke: '#000000',
      theme: {
        'stroke-width': 0,
        states: {
          hover: {
            fill: '#f2f2f2'
          },
          select: {
            fill: '#f2f2f2'
          }
        }
      }
    }
  },
  exporting: {
    buttons: {
      contextButton: {
        symbol: "dots"
      }
    }
  },
};
// Apply the theme
Highcharts.setOptions(Highcharts.theme);
